var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 40,
    viewBox: "0 0 53 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6783 4.53288C25.2513 4.89041 25.7556 5.06662 25.5 5.87598H27.5C27.2179 5.12804 27.5257 4.95835 28.0281 4.63374C30.0711 3.31547 28.4557 0.150369 26.3863 0.00560971C23.9951 -0.154512 22.4392 3.15542 24.6783 4.53288Z",
    fill: "#1A1346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 7.62122C10.0424 7.62122 1.81107 20.5951 1.81107 30.8057H50.3834C51.5867 20.9527 41.98 7.62122 26.4809 7.62122Z",
    fill: "#1A1346"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9645 32.4818H3.07652C1.37518 32.4818 0 33.8505 0 35.5438V36.2326C0 37.9259 1.37518 39.2946 3.07652 39.2946H48.9622C50.6636 39.2946 52.0388 37.9259 52.0388 36.2326V35.5438C52.041 33.8527 50.6658 32.4818 48.9645 32.4818Z",
    fill: "#1A1346"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrders);
export default __webpack_public_path__ + "static/media/ic-orders.f0eb79ef89ce6d5b6264d22663b4282e.svg";
export { ForwardRef as ReactComponent };